import gql from 'graphql-tag'

export const GET_PARTNER_CLIENT_LIST = gql`
  query allClientDetails($partnerLoginId: Int) {
    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {
      clientName
      loginId
    }
  }
`

export const GET_FUEL_SENSOR_DETAILS = gql`
  query GetFuelSensorDetails {
    getFuelSensorDetails {
      fuelSensorId
      fuelSensorName
      fuelDeviceType
    }
  }
`
export const GET_FUEL_SENSOR_ASSIGNMENTS = gql`
  query GetFuelSensorAssignments($fuelSensorId: String, $status: String) {
    getFuelSensorAssignments(fuelSensorId: $fuelSensorId, status: $status) {
      uuid
      status
      imeiNumber
      uniqueId
      fuelSensorId
    }
  }
`
export const GET_ALL_VEHICLES = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    getAllVehicleDetails(clientLoginId: $clientLoginId) {
      entityId
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`

export const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

export const ADD_VEHICLES = gql`
  mutation excelFileUpload(
    $fileInfo: FileUploadInput!
    $secondaryFileInfo: FileUploadInput!
    $commonInput: CommonInput!
    $tanks: JSON
  ) {
    excelFileUpload(
      fileInfo: $fileInfo
      secondaryFileInfo: $secondaryFileInfo
      commonInput: $commonInput
      tanks: $tanks
    ) {
      failedToUpload
      totalExcelDataRecords
      totalDuplicateRecords
      successfullyUploaded
      failedUploadList
    }
  }
`

export const GET_CALIBRATION_DETAILS = gql`
  query getFuelCalibrationDetail($entityId: Int) {
    getFuelCalibrationDetail(vehicleId: $entityId) {
      # refuelThreshold
      # drainThreshold
      # medianFilter
      fuelUserType
      fuelSensorType
      minTankCapacity
      minValue
      maxTankCapacity
      totalFuelTank
      maxValue
      # pfPerMin
      pilferageTolerance
      # minimumPilferageDuration
      calibration_filename
      url
      # overallThreshold
      availableDataTypes
      preferedDataType
      # secondary tank
      hasSecondaryTank
      hasInSameTank
      isDualSensor
      useTaabiAlgo
      # obdAlgo
      # fuelSensorAlgo
      secondaryTankMinCapacity
      secondaryTankMaxCapacity
      secondaryTankTotalFuel
      secondaryTankMinValue
      secondaryTankMaxValue
      secondaryPolynomialEquation
      secondary_tank_calibration_filename
      secondaryUrl
      fuelSensorNames
      fuelSensorIMEIs
      tanks
    }
  }
`
export const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`
export const GET_ALL_ALGO = gql`
  query getAllAlgos {
    getAllAlgos {
      algoName
      algoInt
    }
  }
`

export const ADD_ELOCK_CONNECTION = gql`
mutation AddELOCKconnection($uniqueId: String!, $status: Int!, $deviceType: String!) {
  addELOCKconnection(uniqueId: $uniqueId, status: $status, deviceType: $deviceType) 
}
`


// WEBPACK FOOTER //
// ./src/queries.js